// custom-actions.service.ts
import {Injectable} from '@angular/core';
import {FileModel, UploadService} from "@alfresco/adf-content-services";
import {AlgRenditionService} from "../src/lib/alg-rendition.service";

@Injectable({
  providedIn: 'root'
})
export class ConvertPdfService {

  constructor(
    private uploadService: UploadService,
    private algRenditionService: AlgRenditionService
  ) {
  }

  convertToPdf(node: any) {
    if (node && node.name && !node.name.toLowerCase().endsWith('.pdf')) {
      this.algRenditionService.getRendition(node.id).subscribe((rendition: any) => {
        if (rendition.entry.status === "CREATED") {
          this.algRenditionService.getRenderedPdf(node.id).subscribe((res: any) => {
            node.name = node.name.substring(0, node.name.lastIndexOf('.'));
            this.uploadFile(node, res);
          });
        } else {
          this.algRenditionService.requestPdfRendition(node.id).subscribe((status) => {
            if (status === "CREATED") {
              this.algRenditionService.getRenderedPdf(node.id).subscribe((res: any) => {
                node.name = node.name.substring(0, node.name.lastIndexOf('.'));
                this.uploadFile(node, res);
              });
            }
          });
        }
      });
    } else {
      alert("L'action n'est pas disponible pour les documents PDF");
    }
  }

  uploadFile(node: any, blob: Blob) {
    let file = new File([blob], node.name + '.pdf', {type: 'application/pdf'});
    let fileModel: FileModel = new FileModel(file, {parentId: node.parentId});
    this.uploadService.addToQueue(fileModel);
    this.uploadService.uploadFilesInTheQueue();
  }

}
